/**
 * JavaScript Document
 * Version: 1.0.0
 * Date: 4/20/2020
 * Author: Liu Changkun
 * Copyright: www.east.net
 */
import http, { formConfig } from "@/utils/http";
const url = action => `/auth/${action[0]}`;

export default class AUTH {
  static LIST(params) {
    return http.get(url`list`, { params });
  }
  static CHGPWD(data) {
    return http.post(url`chgpwd`, data, formConfig);
  }
  static ADD(data) {
    return http.post(url`add`, data, formConfig);
  }
  static EDIT(data) {
    return http.post(url`edit`, data, formConfig);
  }
  static DELETE(data) {
    return http.post(url`delete`, data, formConfig);
  }
}
